module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAAAn0lEQVRIx2NgMG3AhXjt24AIj4JLAiZkIwZchjKaNUxccQKIgAy6WgxEasGTgQjCFnHtoq3FTOaNGe1bfAqXIQumtGxauPUCUIq2Pi7q35nQuAFZRMa7T96vn35BDQmA3O5tLBZNdI1jCFINmkTXxMVq2WSeOBuIgAy6Wsxh3bL39D0gAjLonZ30o6YDEa0KEEo0j1o8avGoxaMWDwgCAG82KgUeRNy9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/ws.png
// module id = 414
// module chunks = 0